module.exports = __webpack_public_path__ + "images/icons_v2/star-outlined-5ee69d00.svg";